"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeFacilityConfig = exports.facilityConfigVehicles = exports.facilityConfigSchema = exports.FACILITY_CONFIG_VERSION = void 0;
var prisma_1 = require("@ambler/prisma");
var zod_1 = require("zod");
exports.FACILITY_CONFIG_VERSION = 1;
// Where a value was read in a source file, so that a message can point at it. Never serialized.
var sourceRefSchema = zod_1.z.object({ sheet: zod_1.z.string(), line: zod_1.z.number().int() });
var fieldStateSchema = zod_1.z.nativeEnum(prisma_1.$Enums.FieldState);
// An absent list keeps the defaults of the vehicle
var vehicleLabelsSchema = zod_1.z.object({
    AMBULANCE: zod_1.z.array(zod_1.z.string()).optional(),
    VSL: zod_1.z.array(zod_1.z.string()).optional(),
    TPMR: zod_1.z.array(zod_1.z.string()).optional(),
    BARIATRIC: zod_1.z.array(zod_1.z.string()).optional(),
    PARAMEDICAL: zod_1.z.array(zod_1.z.string()).optional(),
    MEDICAL: zod_1.z.array(zod_1.z.string()).optional(),
});
// Booking settings live on each unit: a facility tuned unit by unit must survive an export
var tunnelSchema = zod_1.z.object({
    patientFields: zod_1.z.object({
        ipp: fieldStateSchema.optional(),
        nir: fieldStateSchema.optional(),
        visitId: fieldStateSchema.optional(),
        birthdate: fieldStateSchema.optional(),
        phone: fieldStateSchema.optional(),
        room: fieldStateSchema.optional(),
    }),
    doctorField: fieldStateSchema.optional(),
    vehicles: zod_1.z.object({
        AMBULANCE: zod_1.z.boolean().optional(),
        VSL: zod_1.z.boolean().optional(),
        TPMR: zod_1.z.boolean().optional(),
        BARIATRIC: zod_1.z.boolean().optional(),
        PARAMEDICAL: zod_1.z.boolean().optional(),
        MEDICAL: zod_1.z.boolean().optional(),
    }),
    specificNeeds: vehicleLabelsSchema,
    patientConditions: vehicleLabelsSchema,
});
var serviceSchema = zod_1.z.object({
    name: zod_1.z.string().min(1),
    type: zod_1.z.nativeEnum(prisma_1.$Enums.MedicalFacilityDepartmentType),
    floor: zod_1.z.string(),
    phone: zod_1.z.string().optional(),
    uf: zod_1.z.string().optional(),
    ref: sourceRefSchema.optional(),
});
var unitSchema = zod_1.z.object({
    name: zod_1.z.string().min(1),
    hospitalType: zod_1.z.nativeEnum(prisma_1.$Enums.HospitalType),
    transportReasonTemplate: zod_1.z.nativeEnum(prisma_1.$Enums.TransportReasonTemplate).optional(),
    services: zod_1.z.array(serviceSchema).min(1),
    tunnel: tunnelSchema,
    ref: sourceRefSchema.optional(),
});
var doctorSchema = zod_1.z.object({
    rpps: zod_1.z.string().min(1),
    lastname: zod_1.z.string(),
    firstname: zod_1.z.string(),
    ref: sourceRefSchema.optional(),
});
/**
 * The configuration of a facility, independent of any environment: it names things by FINESS, name, UF
 * and RPPS, never by database id. A FDR is read into it, and it is the only input of an import.
 */
exports.facilityConfigSchema = zod_1.z.object({
    version: zod_1.z.literal(exports.FACILITY_CONFIG_VERSION),
    facility: zod_1.z.object({ finess: zod_1.z.string().min(1) }),
    units: zod_1.z.array(unitSchema).min(1),
    doctors: zod_1.z.array(doctorSchema),
});
exports.facilityConfigVehicles = [
    'AMBULANCE',
    'VSL',
    'TPMR',
    'BARIATRIC',
    'PARAMEDICAL',
    'MEDICAL',
];
var serializeFacilityConfig = function (config) {
    return JSON.stringify(config, function (key, value) { return (key === 'ref' ? undefined : value); }, 2);
};
exports.serializeFacilityConfig = serializeFacilityConfig;
//# sourceMappingURL=schema.js.map